// @flow
import React from 'react';
import {Chip} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import {colors} from '../../assets/styles/colors';
import UpgradeIcon from '../icons/UpgradeIcon';

const useStyles = makeStyles(theme => ({
  root: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      fontSize: '0.875rem',
      color: colors.purple3,
    },
  },
  label: {
    display: 'flex',
    color: colors.purple3,
    fontWeight: 600,
    justifyContent: 'center',
    alignItems: 'center',
    gap: '.5rem',
  },
}));

export default function PremiumFeatureBadge() {
  const classes = useStyles();

  return (
    <Chip
      component="span"
      label={
        <span className={classes.label}>
          Mejora tu plan
          <UpgradeIcon width={18} height={18} />
        </span>
      }
      size="small"
      className={classes.root}
    />
  );
}
